export const DESIGN_TOKENS = {
    brand: {
        primaryHex: '#354F38',
        primaryDarkHex: '#2C3E30',
        primaryBgClass: 'bg-[#354F38]',
        primaryTextClass: 'text-[#354F38]',
        primaryHoverTextClass: 'hover:text-[#354F38]',
        primaryBorderClass: 'border-[#354F38]',
        primaryLightBgClass: 'bg-[#354F38]/10',
        primaryLightHoverBgClass: 'hover:bg-[#354F38]/5',
        primaryDarkHoverBgClass: 'hover:bg-[#2C3E30]',
        primaryShadowSoftClass: 'shadow-[#354F38]/20',
        primaryTextDarkClass: 'text-[#2C3E30]',
        primaryRingSoftClass: 'ring-[#354F38]/10',
        primaryBorderSolidClass: 'border-[#354F38]',
        primaryBgSoftClass: 'bg-[#354F38]/5',
    },
    chart: {
        visitTypeColorByName: {
            전화: '#3B82F6',
            문자: '#10B981',
            대면: '#F59E0B',
            심방: '#8B5CF6',
            기도: '#EC4899',
            교제: '#06B6D4',
            기타: '#6B7280',
        },
    },
    surface: {
        cardClass: 'bg-white/95 backdrop-blur-xl border border-gray-100 shadow-2xl',
        softCardClass: 'bg-white/90 backdrop-blur-2xl border border-white/50 shadow-2xl',
        inputClass: 'bg-[#F9F9F8] border border-gray-200 text-gray-900',
        inputFocusClass: 'focus:bg-white focus:outline-none',
    },
    shape: {
        roundedXlClass: 'rounded-xl',
        rounded2xlClass: 'rounded-2xl',
    },
};
